export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["طلب إلى الدعم الفني"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["من"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الدردشة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إضافة رسالة"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الملفات"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يمكنك تحميل ملف واحد أو عدة ملفات. الحجم الأقصى للملف هو 10 ميجابايت."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نص الرسالة"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال"])}
}